import { Channel } from 'client/model/skill';

import { routes } from '../../lib/routes';
import { ImplicitSurface, Surface } from '../../lib/surfaces';
import { AudioPlayerState, Message } from '../../types/skillTest';
import { callApi } from '../utils';

interface SendMessageParams {
    skillId: string;
    channel: Channel;
    text: string;
    isDraft: boolean;
    sessionId?: string;
    sessionSeq?: number;
    payload?: string;
    surface?: ImplicitSurface | Surface;
    directives?: unknown[];
    audioPlayerState?: AudioPlayerState;
}

export const sendMessage = (args: SendMessageParams) => {
    const { skillId, channel, ...data } = args;
    return callApi<Message>({
        method: 'POST',
        url: routes.app.appStoreApi(`apps/${skillId}/testing/message`),
        queryParams: { channel },
        data,
    });
};

export const logoutFromSkill = (args: { channel: Channel; skillId: string; isDraft: boolean }) => {
    const { channel, skillId, ...data } = args;
    return callApi<{ result: boolean }>({
        method: 'POST',
        url: routes.app.appStoreApi(`alice-skills/${skillId}/testing/logout`),
        queryParams: { channel },
        data,
    });
};
